"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactstrap = require("reactstrap");
var _propTypes = _interopRequireDefault(require("prop-types"));
require("./style.css");
class ToolTips extends _react.default.Component {
  constructor(props) {
    super(props);
    this.state = {
      tooltipOpen: false
    };
    this.toggle = this.toggle.bind(this);
  }
  toggle() {
    const {
      tooltipOpen
    } = this.state;
    this.setState({
      tooltipOpen: !tooltipOpen
    });
  }
  render() {
    const {
      placement,
      disabled,
      children,
      text,
      className,
      style = Object.assign({}, this.props.style)
    } = this.props;
    const {
      tooltipOpen
    } = this.state;
    const cursor = disabled ? 'tool-tips' : '';
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, children && /*#__PURE__*/_react.default.createElement("span", {
      className: `tool-tip ${cursor} ${className}`,
      id: disabled ? children.props.id : ''
    }, children, text.length !== 0 && /*#__PURE__*/_react.default.createElement(_reactstrap.Tooltip, {
      placement: placement,
      isOpen: tooltipOpen,
      target: children.props.id,
      toggle: this.toggle,
      className: disabled ? '' : 'sidebar--icon-tooltip',
      style: style
    }, text)));
  }
}
ToolTips.defaultProps = {
  placement: 'top',
  text: 'Default tooltip content'
};
ToolTips.propTypes = {
  className: _propTypes.default.string,
  children: _propTypes.default.shape(),
  disabled: _propTypes.default.bool,
  placement: _propTypes.default.string,
  text: _propTypes.default.string
};
var _default = exports.default = ToolTips;